<template>
  <v-card>
    <v-card-title>
      Funcionalidades Utilizada
      <v-spacer />
    </v-card-title>
    <v-card-text v-show="!showCard">
      <div class="text-center ma-12" align="center">
        <v-progress-circular
          class=""
          :indeterminate="true"
          :rotate="0"
          :size="128"
          value="Loading"
          :width="8"
          color="light-blue"
          >{{ "Loading" }}</v-progress-circular
        >
      </div>
    </v-card-text>
    <highcharts v-if="showCard" :options="chartOptions"></highcharts>
  </v-card>
</template>

<script>
import { Chart } from "highcharts-vue";
import { mapGetters } from "vuex";
import firebase from "@/plugins/firebase";
export default {
  components: {
    highcharts: Chart
  },
  data() {
    return {
      chartOptions: {
        chart: {
          // height: 250,
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false
        },
        title: {
          text: "4185<br><br>Navegações",
          align: "center",
          verticalAlign: "middle",
          y: 6
        },
        accessibility: {
          point: {
            valueSuffix: "%"
          }
        },
        plotOptions: {
          pie: {
            dataLabels: {
              enabled: false,
              // distance: -50,
              style: {
                fontWeight: "bold",
                color: "white",
                textTransform: "capitalize"
              }
            },
            startAngle: 0,
            endAngle: 360,
            size: "100%",
            showInLegend: true
          }
        },
        series: [
          {
            type: "pie",
            innerSize: "50%",
            name: "Navegações",
            data: [],
            style: {
              fontWeight: "bold",
              color: "white",
              textTransform: "capitalize"
            }
          }
        ],

        credits: {
          enabled: false
        }
      },
      showCard: false,
      date_init: "",
      date_end: "",
      isCompany: false,
      company: []
    };
  },

  computed: {
    ...mapGetters("appAnalytics", ["getFilter"]),
    ...mapGetters(["getEmpresas"])
  },
  watch: {
    getFilter(m, v) {
      this.showCard = false;
      this.init();
    }
  },

  methods: {
    async init() {
      const callDate = this.getFilter;
      this.date_init = callDate.date[0];
      this.date_end = callDate.date[1];
      this.company = callDate.empresas;
      this.isCompany = callDate.withCompany;
      var tmpArr = [];
      const app_analytics = firebase
        .functions()
        .httpsCallable("app_analytics/funcionalidadeUtilizada");
      await app_analytics({
        date_init: this.date_init,
        date_end: this.date_end,
        isCompany: this.isCompany,
        company: this.company
      })
        .then(result => {
          result.data.forEach((e, c) => {
            tmpArr.push([e.navScreen, Number(e.total_simulado)]);
          });
        })
        .catch(erro => {
          console.log(erro);
        });
      Promise.all(tmpArr).then(() => {
        this.showCard = !this.showCard;
        this.chartOptions.series[0].data = tmpArr;
      });
    }
  },
  created() {
    this.init();
  }
};
</script>

<style lang="scss"></style>
